import { APCAcontrast, sRGBtoY } from 'apca-w3'
import color from 'color'

const WHITE_Y = sRGBtoY([255, 255, 255])
const BLACK_Y = sRGBtoY([0, 0, 0])

/**
 * Picks the readable text color for an arbitrary background color, matching
 * the selection rule of the patched `@csstools/css-color-parser` that computes
 * `contrast-color()` for theme stylesheets: the APCA contrast of white and
 * black text is compared after rounding to one decimal, and white is chosen
 * only when strictly greater. A parity spec asserts both implementations
 * pick the same color.
 */
export function getContrastTextColor(backgroundColor: string): '#ffffff' | '#000000' {
  let channels: { r: number; g: number; b: number }
  try {
    channels = color(backgroundColor).rgb().object() as { r: number; g: number; b: number }
  } catch {
    return '#000000'
  }
  const backgroundY = sRGBtoY([channels.r, channels.g, channels.b])
  const whiteLc = Number.parseFloat(Math.abs(Number(APCAcontrast(WHITE_Y, backgroundY))).toFixed(1))
  const blackLc = Number.parseFloat(Math.abs(Number(APCAcontrast(BLACK_Y, backgroundY))).toFixed(1))
  return whiteLc > blackLc ? '#ffffff' : '#000000'
}
